import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

export default (TYPE) => () => createAction(TYPE, createRequestPayload('international', '/resolve/v1/missed-payments'));
